import type { SeedStatsDto } from '@/core/data/seed/seed.interface';
import type { SeedRepository } from '@/core/data/seed/seed.repository';
import type { ApiError, Result } from '@/core/network/http/httpClient.interface';
import { generalError } from '@/core/network/http/httpError';

export class SeedService {
  private readonly repository: SeedRepository;

  constructor(repository: SeedRepository) {
    this.repository = repository;
  }

  async getStats(): Promise<Result<SeedStatsDto>> {
    try {
      const response = await this.repository.getStats();
      return response?.data ? { data: response.data } : { error: generalError() };
    } catch (error) {
      return { error: error as ApiError };
    }
  }
}
